import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { sanitizeHtml } from "../../../helpers/sanitizeHtml";
import { FileProcessModel } from "../../../hooks/community/models/FileProcessModel";
import { defaultProfileImage } from "../../../utils/constants";
import { CommunityDiscussComments } from "../models/CommunityDiscussComments";
import { CommunityCommentsWrapper } from "./CommunityCommentsWrapper";
import { CommunityInputComment } from "./CommunityInputComment";

type Props = {
    avatar: string;
    author: string;
    tags: string[];
    title: string;
    content: string;
    comments: CommunityDiscussComments[];
    onSendComment: (value: string, reply?: CommunityDiscussComments) => void;
    onReactComment: (comment: CommunityDiscussComments) => void;
    files: FileProcessModel[];
    onAddFile: (file: File) => void;
    onRemoveFile: (file: FileProcessModel) => void;
    replySelect: CommunityDiscussComments | null;
    setReplySelect: (comment: CommunityDiscussComments | null) => void;
}

export const CommunityDetails = ({ avatar, author, tags, title, content, comments, onSendComment, onReactComment, files, onAddFile, onRemoveFile, replySelect, setReplySelect }: Props) => {
    const history = useHistory();
    
    return (
        <div className="community-details">
            <div className="w-100 tap-flex-center justify-content-start">
                <div className="nb-link-underline-500 w-auto cursor-pointer" onClick={()=> history.replace('/community')}>
                    Back
                </div>
            </div>

            <div className="community-details__info">
                <div className="d-flex flex-row align-items-center">
                    <div className="tags">
                        {tags.map((t, i) => (
                            <span key={i}>{t}</span>
                        ))}
                    </div>

                    <div className="author">
                        <img src={toAbsoluteUrl(avatar) || defaultProfileImage} onError={(e) => { e.currentTarget.src = defaultProfileImage }} alt={author} />
                        <span>{author}</span>
                    </div>
                </div>
                <h2>{title}</h2>

                <p dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}></p>
            </div>
            <div className="community-details__comments">
                <CommunityCommentsWrapper 
                    comments={comments}
                    onReply={setReplySelect}
                    onReact={onReactComment}
                />
            </div>

            <CommunityInputComment 
                onSendComment={(v) => onSendComment(v, replySelect ?? undefined)}
                cleanReply={() => setReplySelect(null)}
                reply={replySelect ?? undefined}
                files={files}
                onAddFile={onAddFile}
                OnRemoveFile={onRemoveFile}
            />
        </div>
    )
}